import React from 'react';
import { Heart } from 'lucide-react';

const GUIDELINES = [
  'Introduce un alimento nuevo cada 3-5 días para detectar posibles alergias',
  'Evita añadir sal o azúcar a las comidas del bebé',
  'Asegúrate de que las texturas sean apropiadas para la edad',
  'Mantén una buena higiene en la preparación de alimentos'
];

export const SafetyGuidelines: React.FC = () => {
  return (
    <div className="mt-6 bg-white rounded-lg p-4">
      <h3 className="font-semibold mb-3 flex items-center gap-2">
        <Heart size={20} className="text-pink-500" />
        Recomendaciones generales
      </h3>
      <ul className="space-y-2 text-sm text-gray-700">
        {GUIDELINES.map((guideline, index) => (
          <li key={index} className="flex items-start gap-2">
            <span className="text-pink-500">•</span>
            {guideline}
          </li>
        ))}
      </ul>
    </div>
  );
};